import { useState, useMemo } from 'react';
import { Autocomplete, TextField, Box, Typography } from '@mui/material';
import { useAuthContext } from 'src/auth/hooks';
import { useSnackbar } from 'src/components/snackbar';
import { messageDecodify } from 'src/helpers/messageDecodify';


export default function SucursalDrop() {
    const { enqueueSnackbar } = useSnackbar();
    const { user: dataUser, updateCompany } = useAuthContext();
    const defaultEmpresa = useMemo(() => {
        const empresa = dataUser?.empresas?.filter((x)=> x.id === dataUser.idEmpresa)
        if(empresa){
            return empresa[0]
        }
        return []
    }, [dataUser]);
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState(defaultEmpresa);

    const handleChangeEmpresa = async(e,value) =>{
        try {
            const dataPayload = {
                usuarioId: dataUser.usuarioId,
                empresaId: value.id
            }
            const response = await updateCompany?.(dataPayload)
            if(response.data.code === 200){
                setEmpresaSeleccionada(value)
                window.location.reload();
            }else{
                enqueueSnackbar(response.data.message);
            }
        } catch (error) {
            enqueueSnackbar(messageDecodify(error), { variant: 'error' });
        }
    }

    return (
        <Box
        sx={{
            minWidth: 220,
            display: 'flex',
            alignItems: 'center',
        }}
        >
        <Autocomplete
            disableClearable   
            size="small"
            value={empresaSeleccionada}
            options={dataUser?.empresas || []}
            getOptionLabel={(option) => option?.name || ''}
            onChange={handleChangeEmpresa}
            sx={{
            '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: 'background.paper',
                boxShadow: 1,
            },
            width: 220
            }}
            renderInput={(params) => (
            <TextField
                {...params}
                placeholder="Seleccionar sucursal"
                label="Sucursal"
            />
            )}
            renderOption={(props, option) => (
            <li {...props}>
                <Typography>{option.name}</Typography>
            </li>
            )}
        />
        </Box>
    );
}